import React from 'react';
import { FileText } from 'lucide-react';

export function StatuteHero() {
  return (
    <div className="text-center mb-16">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-accessible-red-600/10 rounded-full mb-6">
        <FileText className="w-8 h-8 text-accessible-red-600" aria-hidden="true" />
      </div>
      <h1 className="heading-1 mb-4">
        Statut Fundacji
      </h1>
      <p className="body-large">
        STATUT FUNDACJI „ZNAJDKI"
      </p>
    </div>
  );
}